<template>
  <a-modal
    width="800px"
    title="选择配方"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-descriptions>
      <a-descriptions-item label="当前线路">禽</a-descriptions-item>
      <a-descriptions-item label="当前工厂">{{selectFactory}}</a-descriptions-item>
      <a-descriptions-item label="配方类型">配合饲料</a-descriptions-item>
    </a-descriptions>
    <a-row :gutter="24">
      <a-col :span="8">
        <a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }" label="配方名称：">
          <a-input placeholder="请输入" v-model="formulaName" @pressEnter="searchFormula"/>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" label="动物类型：">
          <a-select style="width: 160px;" placeholder="请选择" v-model="animalType" @change="selectAnimalType">
            <a-select-option v-for="el in animalTypeList" :key="el.id" :value="el.id">
              {{ el.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-button type="primary" @click="searchFormula">查询</a-button>
        <a-button style="margin: 8px 20px 0px 8px"  @click="reset">重置</a-button>
      </a-col>
    </a-row>
    <a-table 
      :pagination="pagination" 
      :columns="formulaColumns" 
      :data-source="formulaList"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, type: 'radio',onChange:onSelectChange}" 
    >
      <span slot="formulaName" slot-scope="text, record">
        <a @click="handleClick(record)">{{record.formulaName}}</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import {formulaColumns} from '../Columns'

export default {
  props:['selectFactory','factoryId','visible'],
  data(){
    return{
      formulaName:'',
      animalType:undefined,
      animalTypeList:[],
      animalTypeId:'',
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.searchFormula({ current, pageSize });
        }, //选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this.searchFormula({ current: 1, pageSize });
        }, //每页多少条
      },
      formulaColumns,
      formulaList:[],
      selectedRowKeys: [],
      roultryId:'',
      showRow:[],
      index:''
    }
  },
  mounted(){
    this.AnimalTypeGet()
  },
  methods:{
    handleClick(record){
      let {href} = this.$router.resolve("/nhf-compound-editor?id="+record.id)
      window.open(href,'_blank')
    },
    handleOk() {
      this.$emit('isShow', false)
      this.$emit('getSelect', this.showRow , this.index)
    },
    handleCancel() {
      this.$emit('isShow', false)
    },
    selectAnimalType(value){
      this.animalTypeId = value
    },
    async AnimalTypeGet() {
      let factoryId = this.factoryId
      const res = await this.$http.get("/iot-factory/FactoryAnimal/listByParentId", { params:{parentId:0,factoryId} })
      let { data } = res;
      if(data && data.length && data[0].id){
        const resAnimal = await this.$http.get("/iot-factory/FactoryAnimal/listByParentId",  { params:{parentId:data[0].id,factoryId}})
        this.roultryId = resAnimal.data.find(item => item.name == '2 禽')?.id
        if(this.roultryId){
          const animal = await this.$http.get("/iot-factory/FactoryAnimal/listByParentId",  { params:{parentId:this.roultryId,factoryId}})
          this.animalTypeList = animal.data
        }
      }
    },
    async searchFormula(val){
      if(!this.roultryId) return 
      const { current = 1, pageSize = 10 } = val;
      let factoryId = this.factoryId
      let staffId = window.localStorage.getItem('staffId')
      let params = {
        staffId,
        factoryId,
        baseAnimalTypeId:this.roultryId,
        current,
        size:pageSize,
        animalTypeId:this.animalTypeId,
        formulaName:this.formulaName
      }
      const res = await this.$http.get("/nhf-app/api/sat/collect/formula", { params })
      let { success,data } = res;
      if(success){
        let {records,current=1,total=0,size=10} = data;
        this.pagination.current = current
        this.pagination.pageSize = size
        this.pagination.total = total
        this.formulaList = records || []
      }
      this.selectedRowKeys = []
    },
    reset(){
      this.formulaName = '',
      this.animalType = undefined,
      this.animalTypeId = '',
      this.searchFormula({})
      this.selectedRowKeys = []
    },
    onSelectChange(selectedId, record) {
      this.selectedRowKeys = selectedId
      this.showRow = record
    },
    initRecord(index){
      this.index = index
    }
  }
}
</script>

<style>

</style>